import { render, staticRenderFns } from "./RecruitmentJobUpdate.vue?vue&type=template&id=48de7ca5"
import script from "./RecruitmentJobUpdate.vue?vue&type=script&lang=js"
export * from "./RecruitmentJobUpdate.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentJobUpdate.vue?vue&type=style&index=0&id=48de7ca5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports